module.exports = __webpack_public_path__ + "static/media/Brittney Parker Headshot_1692638621214.9b46ca73.jpeg";